// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SectionContainer, SectionTitle } from "@guestsupply/App/Widgets/DesignSystem/DesignSystem.helpers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface TooltipTabStyles {
    titleGridItem?: GridItemProps;
    gridItem?: GridItemProps;
    typographyWrapper?: InjectableCss;
}

const styles: TooltipTabStyles = {
    titleGridItem: {
        width: 12,
    },
    gridItem: {
        width: 12,
        css: css`
            flex-wrap: wrap;
            padding-bottom: 40px;
        `,
    },
    typographyWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            margin-top: 20px;
        `,
    },
};

const TypographyTab = () => {
    return (
        <SectionContainer>
            <GridItem {...styles.titleGridItem}>
                <SectionTitle>{translate("Tooltip")}</SectionTitle>
            </GridItem>
            <GridItem width={12}>
                <StyledWrapper {...styles.typographyWrapper}>
                    <StyledWrapper>
                        <Typography variant="h1" as="h1">
                            This is Headline 1
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Typography variant="h2" as="h2">
                            This is Headline 2
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Typography variant="h3" as="h3">
                            This is Headline 3
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Typography variant="h4" as="h4">
                            This is Headline 4
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Typography variant="h5" as="h5">
                            This is Headline 5
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Typography variant="h6" as="h6">
                            This is Headline 6
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Typography variant="p" as="p">
                            This is Paragraph
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Typography variant="legend" as="legend">
                            This is Legend
                        </Typography>
                    </StyledWrapper>
                </StyledWrapper>
            </GridItem>
        </SectionContainer>
    );
};

export default TypographyTab;
